import { treatErrorAs, handleErrorsInQueue } from 'api/errors';
import { errorLevel } from 'constants/errors';

// Finders
import { findFieldBoundariesByFieldUuid } from 'boundaries/finders';
import { findProductFeaturesByFieldUuid } from 'product-features/finders';

// Action Creators
import {
  completeProductFeaturesLoading,
  completeBoundaryLoading
} from 'api/loading';
import {
  setActiveFieldIdentifier
} from 'current';

/** Loads field and associated data. Can be called during initial load of data, or again later after things are
  already loaded. ignoreRoute flag can be set to true to avoid using information in the route URL, which is useful
  when the URL is meant to update *AFTER* everything is loaded.
  */
export const requestFieldData = ({dispatch, getState, fieldId, fieldUuid }) => {
  return Promise.resolve()
  .then( () => {
    dispatch(setActiveFieldIdentifier({ fieldId, fieldUuid }));
    return findProductFeaturesByFieldUuid({dispatch, getState, fieldUuid})
    .catch( treatErrorAs({ severity: errorLevel.WARN }) )
    .then( () => dispatch(completeProductFeaturesLoading()) );
  })
  .then( () => Promise.all([
    findFieldBoundariesByFieldUuid({dispatch, getState, fieldUuid})
    .then( () => dispatch(completeBoundaryLoading()) )
  ]) )
  .catch( treatErrorAs({ severity: errorLevel.BLOCK, andStopHere:true }) )
  .then( () => handleErrorsInQueue() );
};

export default requestFieldData;
